import type React from "react";
import { useId, useState } from "react";
import {
	ModalAction,
	type ModalCloser,
	ModalContent,
} from "~/components/Modal";

interface Props {
	setAgree: (v: boolean) => void;
	closeModal: ModalCloser;
}

export const InvitationWaringModal: React.FC<Props> = ({
	setAgree,
	closeModal,
}) => {
	const id = useId();
	const [acceptCannotMove, setAcceptCannotMove] = useState<boolean>(false);
	const [acceptCannotUpdateEmail, setAcceptCannotUpdateEmail] =
		useState<boolean>(false);
	const [acceptTerms, setAcceptTerms] = useState<boolean>(false);

	return (
		<>
			<ModalContent>
				<div>
					<div className="text-error text-center">
						<h2 className="font-normal text-xl font-semibold mb-4">
							WARNING !
						</h2>
						<p>
							If you accept this invitation,
							<br />
							you need to accept the following conditions.
						</p>
					</div>
					<div className="mt-12">
						<div className="flex	gap-4 mt-8">
							<input
								type="checkbox"
								name="accept-cannot-move"
								className="checkbox t4-checkbox"
								onChange={(e) => setAcceptCannotMove(e.target.checked)}
								id={`${id}-accept-cannot-move`}
							/>
							<label htmlFor={`${id}-accept-cannot-move`}>
								You cannot move to other organization unless you get the
								permission from the admin of the organization.
							</label>
						</div>
						<div className="flex gap-4 mt-8">
							<input
								type="checkbox"
								className="checkbox t4-checkbox"
								name="accept-cannot-update-email"
								onChange={(e) => setAcceptCannotUpdateEmail(e.target.checked)}
								id={`${id}-accept-cannot-update-email`}
							/>
							<label htmlFor={`${id}-accept-cannot-update-email`}>
								You cannot change your name and email unless you are the admin
								of the organization.
							</label>
						</div>
						<div className="flex gap-4 mt-8">
							<input
								type="checkbox"
								className="checkbox t4-checkbox"
								name="accept-terms"
								onChange={(e) => setAcceptTerms(e.target.checked)}
								id={`${id}-accept-terms`}
							/>
							<label htmlFor={`${id}-accept-terms`}>
								I have read and agree to the{" "}
								<a href="/terms" target="_blank" rel="noopener noreferrer">
									terms & conditions
								</a>
							</label>
						</div>
					</div>
				</div>
			</ModalContent>
			<ModalAction>
				<button
					type="button"
					onClick={() => {
						setAgree(true);
						closeModal();
					}}
					className="btn btn-lg btn-t4-primary rounded-full"
					disabled={
						!acceptCannotMove || !acceptCannotUpdateEmail || !acceptTerms
					}
				>
					ACCEPT
				</button>
			</ModalAction>
		</>
	);
};
